document.addEventListener('DOMContentLoaded', function () {
  const openingScreen = document.getElementById('opening-animation');
  if (!openingScreen) return;

  const img = openingScreen.querySelector('img');

  const GIF_DURATION = 3000;
  const EXTRA_BUFFER = 100;

  let pageLoaded = false;
  let animationCompleted = false;
  let animationTimerStarted = false;

  // ✅ No image = no animation to wait for
  if (!img) {
    animationCompleted = true;
  }

  const tryFadeOut = () => {
    if (pageLoaded && animationCompleted) {
      openingScreen.classList.add('fade-out');
    }
  };

  /* 1️⃣ Page load */
  window.addEventListener('load', () => {
    pageLoaded = true;
    tryFadeOut();
  });

  /* 2️⃣ Image load + GIF duration */
  const onImageReady = () => {
    if (animationTimerStarted) return;
    animationTimerStarted = true;

    setTimeout(() => {
      animationCompleted = true;
      tryFadeOut();
    }, GIF_DURATION + EXTRA_BUFFER);
  };

  if (img && !animationCompleted) {
    if (img.complete) {
      onImageReady();
    } else {
      img.addEventListener('load', onImageReady, { once: true });
      img.addEventListener('error', onImageReady, { once: true });
    }
  }
});